// @flow

import React from 'react'
import styles from './styles.scss'
import { classnames } from '@/helpers'

type TitleProps = {|
  title?: string,
  subtitle?: string,
|}

const Title = (props: TitleProps) => {
  const { title, subtitle } = props
  return (
    <div className={classnames(styles.row, styles.title)}>
      <div>
        <h6>{title}</h6>
        <h2>{subtitle}</h2>
      </div>
    </div>
  )
}

Title.defaultProps = {
  title: '',
  subtitle: '',
}

export default Title
